'use strict';

export default class ResourceInpageSearch {
    constructor() {
        // On resources landing page
        if ($('.page-node-type-landing-page-resources').length) {


            var $html = `
        <div class="search-bar quick-resources">
            <form action="/resources/search" autocomplete="off" method="GET">
                <div class="search-box-elements">
                    <div id="search-box-quick-resources"><input autocomplete="off" class="ais-SearchBox-input" id="search-box-quick-text-resources"
                            name="search_resources[query]" placeholder="Search" type="text" /><button
                            class="ais-SearchBox-submit" title="Submit the search query." type="submit"><svg
                                class="ais-SearchBox-submitIcon" height="10" viewbox="0 0 40 40" width="10"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z">
                                </path>
                            </svg></button></div>
        
                    <div id="voice-search-resources">&nbsp;</div>
                </div>
            </form>
        
            <ul id="autocomplete-list-resources">
                <li>&nbsp;</li>
            </ul>
        </div>        
        `;
            $('.resources-inpage-search h2').after($html);





            var renderIndexListItem, renderAutocomplete, customAutocomplete;


            let $template_html;
            let $index_name = 'search_resources';
            let $app_id = 'PV21YPDECK';
            let $app_key = '999fc9d3376250fbb4c0d870bb15e65c';
            let $search_box_element = "#search-box";
            let $search_container = ".search-bar";
            let $page_size = 5;
            let $speechSupported = false;


            let $containers = {
                pagingation: '#pagination',
                search_box: '.search-bar.quick-resources',
                search_box_placeholder: 'Search',
                search_result: '#results',
                facets: '#facets',
                facets_clear: '#facets-clear',
                voice_search: '#voice-search',
                search_container: '.resources-inpage-search .search-box-elements',
                sorting: '#search_sorting',
                stats: '#search_stats',
            }

            // If we have a container then load
            if (haveSearchContainer()) {
                bindShowHideSearchBar();
                // checkIfSpeechSupported();
                // buildTemplates();
                doBunchOfStuff();
                loadAlgoliaSearch();
            }

            function debounce(callback, delay) {
                let timeout;
                return function () {
                    clearTimeout(timeout);
                    timeout = setTimeout(callback, delay);
                }
            }

            function doBunchOfStuff() {


                // Helper for the render function
                function renderIndexListItem($result) {
                    console.log($result);
                    var $html = "";
                    $result.hits.forEach(function ($index, $hit) {
                        var $item = ($result.hits[$hit]);

                        $html += "<li><a href='" + $item.url + "'>" + instantsearch.highlight({ attribute: 'title', hit: $item }) + "</a></li>"
                    });
                    return $html;
                }
                

                // renderIndexListItem = ({ indexId, hits }) => `
                //     ${hits.map((hit, hitIndex) => `<li><p>${instantsearch.highlight({ attribute: 'title', hit })}</p></li>`).join('')}
                // `;

               

                // Create the render function
                renderAutocomplete = (renderOptions, isFirstRender) => {
                    const { indices, currentRefinement, refine, widgetParams } = renderOptions;


                    function refinelist() {
                        refine(document.getElementById("search-box-quick-text-resources").value);
                    }

                    if (isFirstRender) {
                        const input = document.getElementById("search-box-quick-text-resources");
                        const ul = document.getElementById("autocomplete-list-resources");

                        input.addEventListener('input', debounce(refinelist, 600));

                    }

                    widgetParams.container.querySelector('#search-box-quick-text-resources').value = currentRefinement;
                    widgetParams.container.querySelector('#autocomplete-list-resources').innerHTML = indices
                        .map(renderIndexListItem)
                };

                // Create the custom widget
                customAutocomplete = instantsearch.connectors.connectAutocomplete(
                    renderAutocomplete
                );

            }

            function loadAlgoliaSearch() {

                let searchClient = algoliasearch($app_id, $app_key);

                let $search = instantsearch({
                    indexName: $index_name,
                    searchClient,
                    routing: {
                        stateMapping: instantsearch.stateMappings.simple(),
                    },
                });

                $search.addWidgets([

                    instantsearch.widgets.configure({
                        hitsPerPage: $page_size,
                        attributesToSnippet: ['body:30'],
                    }),

                    // Voice search
                    instantsearch.widgets.voiceSearch({
                        container: $containers.voice_search,
                        searchAsYouSpeak: true,
                        templates: {
                            status: `
                          <div class="listening {{isListening}}"><img src="/themes/aba/images/ripple.pink.svg"></div>
                        `,
                        },
                    }),

                    // instantsearch.widgets.index({ indexName: $index_name }),

                    customAutocomplete({
                        showReset: true,
                        autofocus: true,
                        container: document.querySelector('.search-bar.quick-resources'),
                    })
                ]);

                $search.start();

                $search.on('render', function () {
                    console.log('Algolia search complete');
                    displayAutoCompleteList();
                });
            }

            function displayAutoCompleteList() {
                if ($('#search-box-quick-text-resources').val()) {
                    $('#autocomplete-list-resources').show();
                } else {
                    $('#autocomplete-list-resources').hide();
                }
            }

            function checkIfSpeechSupported() {
                if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
                    console.log('speech recognition API supported')
                    $($containers.search_container).addClass('speech-supported');
                    $speechSupported = true;
                } else {
                    console.log('speech recognition API not supported');
                }

            }

            function haveSearchContainer() {
                if (!$($containers.search_box).length) {
                    return false;
                } else {
                    return true;
                }
            }

            function bindShowHideSearchBar() {

                $('.global-search-link').click(function ($event) {
                    
                })
            }


            function removeQuickSearchContainer() {
                // $('#block-searchelementquicksearchbar').hide();
            }

            function addQuickSearchContainer() {
                // $('#block-searchelementquicksearchbar').show();
                // $('#search-box-quick-text').focus();
            }
        }
    }
}
